import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader } from "reactstrap";

import styles from "./PanelSettings.module.scss";
const Button = ({ children, ...props }) => (
  <button type="button" {...props}>
    {children}
  </button>
);

function PanelSettings({
  menu,
  header,
  labelClassName,
  itemClassName,
  iconClassName,
  activeItem,
  onClick,
  type = "button",
}) {
  const [_active, setActive] = useState("");

  useEffect(() => {
    setActive(activeItem);
  }, [activeItem]);

  const handleClick = (path, disabled) => {
    if (!disabled) {
      setActive(path);
      onClick(path);
    }
  };

  const renderItems = (item) => {
    const { title, icon, disabled, description, path, testId = "" } = item;
    const itemTab = new URLSearchParams(path.substring(path.indexOf("?"))).get("tab");

    const Component = type === "button" ? Button : Link;

    const commonProps = {
      key: title,
      className: cx("settings-item d-flex", itemClassName, {
        active: _active === itemTab || _active === path,
        [styles.disabled]: disabled,
      }),
      ...(testId && { "data-testid": testId }),
    };

    const linkProps = {
      to: path,
      onClick: () => handleClick(path, disabled),
      style: { textDecoration: "none" },
    };

    const buttonProps = {
      onClick: () => handleClick(path, disabled),
      disabled,
    };

    const componentProps = type === "button" ? buttonProps : linkProps;

    return (
      <Component {...commonProps} {...componentProps}>
        {icon && (
          <div className={cx("icon", iconClassName)}>
            <FontAwesomeIcon icon={icon} />
          </div>
        )}
        <div className={cx("text d-flex flex-column justify-content-center", labelClassName)}>
          <div className="title">{title}</div>
          {description && <div className="description">{description}</div>}
        </div>
      </Component>
    );
  };

  return (
    <div className="panel-settings">
      <Card>
        {header && (
          <CardHeader className="d-flex justify-content-center align-items-center flex-column bg-light4 p-3_5">
            {header}
          </CardHeader>
        )}
        <CardBody className="px-0">{menu.map(renderItems)}</CardBody>
      </Card>
    </div>
  );
}

PanelSettings.propTypes = {
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      icon: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array, PropTypes.string]),
      disabled: PropTypes.bool,
      path: PropTypes.string,
      testId: PropTypes.string,
    })
  ).isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(), PropTypes.array]),
  labelClassName: PropTypes.string,
  itemClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  activeItem: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["button", "link"]),
};

PanelSettings.defaultProps = {
  labelClassName: "",
  itemClassName: "",
  iconClassName: "",
  header: undefined,
  activeItem: undefined,
  type: "button",
};

export default PanelSettings;
